import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./RelatorioInformacoesTracoExperimentalPrint.css";

export default function RelatorioInformacoesTracoExperimentalPrint({
  htmlTabela = "",
  codigo = "",
  revisao = "0",
  data = "",
  dadosTraco = {},
  interessado = "",
  obra = "",
  onVoltar,
}) {
  const areaCapturaRef = useRef(null);
  const impressaoIniciadaRef = useRef(false);
  const monitorImpressaoRef = useRef(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const [erro, setErro] = useState("");
  const [impressaoSolicitada, setImpressaoSolicitada] = useState(false);
  const valorTraco = (valor) => (valor === undefined || valor === null || valor === "" ? "-" : valor);

  useEffect(() => {
    let ativo = true;
    let urlCriada = "";

    async function gerarPdfPaisagem() {
      const areaCaptura = areaCapturaRef.current;
      if (!areaCaptura) return;

      try {
        setErro("");
        const canvas = await html2canvas(areaCaptura, {
          backgroundColor: "#ffffff",
          scale: 2,
          useCORS: true,
          width: areaCaptura.scrollWidth,
          height: areaCaptura.scrollHeight,
          windowWidth: areaCaptura.scrollWidth,
        });

        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4",
        });
        const larguraUtil = 287;
        const alturaUtil = 200;
        const proporcao = Math.min(
          larguraUtil / canvas.width,
          alturaUtil / canvas.height
        );
        const larguraImagem = canvas.width * proporcao;
        const alturaImagem = canvas.height * proporcao;
        const posicaoX = (297 - larguraImagem) / 2;
        const posicaoY = (210 - alturaImagem) / 2;

        pdf.addImage(
          canvas.toDataURL("image/jpeg", 0.98),
          "JPEG",
          posicaoX,
          posicaoY,
          larguraImagem,
          alturaImagem
        );
        pdf.setProperties({
          title: "Informações consideradas para cálculo do traço experimental",
        });

        urlCriada = URL.createObjectURL(pdf.output("blob"));
        if (ativo) setPdfUrl(urlCriada);
      } catch (error) {
        console.error("Erro ao gerar PDF das informações do traço:", error);
        if (ativo) setErro("Não foi possível gerar o PDF da tabela.");
      }
    }

    const temporizador = window.setTimeout(gerarPdfPaisagem, 100);
    return () => {
      ativo = false;
      window.clearTimeout(temporizador);
      if (monitorImpressaoRef.current) {
        window.clearInterval(monitorImpressaoRef.current);
      }
      if (urlCriada) URL.revokeObjectURL(urlCriada);
    };
  }, [htmlTabela]);

  function imprimirPdf(event) {
    if (impressaoIniciadaRef.current) return;
    impressaoIniciadaRef.current = true;

    const janelaPdf = event.currentTarget.contentWindow;
    window.setTimeout(() => {
      let retornoExecutado = false;
      let impressaoPerdeuFoco = false;
      const voltarAosDetalhes = () => {
        if (retornoExecutado) return;
        retornoExecutado = true;
        if (monitorImpressaoRef.current) {
          window.clearInterval(monitorImpressaoRef.current);
          monitorImpressaoRef.current = null;
        }
        janelaPdf?.removeEventListener("afterprint", voltarAosDetalhes);
        window.removeEventListener("afterprint", voltarAosDetalhes);
        onVoltar?.();
      };

      try {
        if (!janelaPdf) throw new Error("Janela do PDF indisponível.");
        setImpressaoSolicitada(true);
        janelaPdf.addEventListener("afterprint", voltarAosDetalhes, { once: true });
        window.addEventListener("afterprint", voltarAosDetalhes, { once: true });
        monitorImpressaoRef.current = window.setInterval(() => {
          if (!document.hasFocus()) {
            impressaoPerdeuFoco = true;
          } else if (impressaoPerdeuFoco) {
            voltarAosDetalhes();
          }
        }, 250);

        const inicioImpressao = Date.now();
        janelaPdf.focus();
        janelaPdf.print();
        if (Date.now() - inicioImpressao > 1000) voltarAosDetalhes();
      } catch (error) {
        if (monitorImpressaoRef.current) {
          window.clearInterval(monitorImpressaoRef.current);
          monitorImpressaoRef.current = null;
        }
        janelaPdf?.removeEventListener("afterprint", voltarAosDetalhes);
        window.removeEventListener("afterprint", voltarAosDetalhes);
        console.error("Erro ao abrir a impressão do PDF:", error);
        impressaoIniciadaRef.current = false;
        setImpressaoSolicitada(false);
        setErro("Não foi possível abrir a impressão do PDF.");
      }
    }, 300);
  }

  return (
    <div className="relatorio-informacoes-traco-experimental-print">
      {erro ? (
        <div className="erro-informacoes-traco-print">
          <div>{erro}</div>
          {onVoltar && <button onClick={onVoltar}>Voltar</button>}
        </div>
      ) : impressaoSolicitada ? (
        <div className="carregando-informacoes-traco-print">
          <div>Impressão preparada.</div>
          {onVoltar && <button onClick={onVoltar}>Voltar</button>}
        </div>
      ) : (
        <div className="carregando-informacoes-traco-print">
          Preparando impressão em A4 paisagem...
        </div>
      )}
      {pdfUrl && (
        <iframe
          className="iframe-impressao-informacoes-traco"
          src={pdfUrl}
          title="PDF das informações consideradas para cálculo do traço experimental"
          onLoad={imprimirPdf}
        />
      )}

      <div
        ref={areaCapturaRef}
        className="area-captura-informacoes-traco"
      >
        <div className="cabecalho-cadastro-informacoes-traco">
          <div className="titulo-cadastro-informacoes-traco">
            <h1>Estudo de Dosagem Experimental de Concreto</h1>
            <p>{codigo}&nbsp;&nbsp; Rev. {revisao} - {data}</p>
          </div>
          <div className="linha-interessado-obra-informacoes-traco">
            <strong>INTERESSADO:</strong> <span>{interessado}</span>
            <strong>OBRA:</strong> <span>{obra}</span>
          </div>
        </div>
        <table className="tabela-dados-traco-impressao">
          <thead>
            <tr>
              <th>Fator a/c</th>
              <th>Fck (MPa/dias)</th>
              <th>Slump (mm)</th>
              <th>Tolerância Slump (mm)</th>
              <th>TIPO DE CONCRETO</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{valorTraco(dadosTraco.fatorAc)}</td>
              <td>{valorTraco(dadosTraco.fck)}</td>
              <td>{valorTraco(dadosTraco.slump)}</td>
              <td>{valorTraco(dadosTraco.toleranciaSlumpProjeto)}</td>
              <td>{valorTraco(dadosTraco.tipoConcreto)}</td>
            </tr>
          </tbody>
        </table>
        <div dangerouslySetInnerHTML={{ __html: htmlTabela }} />
      </div>
    </div>
  );
}
